module.exports = __webpack_public_path__ + "static/media/NaiParq.4da208a0.png";